import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ComplianceReports from './pages/compliance-reports';
import DataIntegration from './pages/data-integration';
import AnalyticsDashboard from './pages/analytics-dashboard';
import EmployeePortal from './pages/employee-portal';
import Login from './pages/login';
import EmployeeLogin from './pages/employee-login';
import PayBandManagement from './pages/pay-band-management';
import JointAssessments from './pages/joint-assessments';
import LandingPage from './pages/landing-page';
import AuditorPortal from './pages/auditor-portal';
import Settings from './pages/settings';
import ApprovalsPage from './pages/approvals';
import AdminConsolePage from './pages/admin-console';
import SsoLaunchPage from './pages/sso-launch';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const user = localStorage.getItem('user');
  return user ? children : <Navigate to="/landing-page" replace />;
};

// Public Route Component (redirect to dashboard if already logged in)
const PublicRoute = ({ children }) => {
  const user = localStorage.getItem('user');
  if (user) {
    const userData = JSON.parse(user);
    switch (userData?.role) {
      case 'admin': case'manager':
        return <Navigate to="/analytics-dashboard" replace />;
      case 'approver':
        return <Navigate to="/approvals" replace />;
      case 'employee':
        return <Navigate to="/employee-portal" replace />;
      case 'auditor':
        return <Navigate to="/auditor-portal" replace />;
      default:
        return <Navigate to="/analytics-dashboard" replace />;
    }
  }
  return children;
};

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public Routes */}
        <Route path="/" element={<Navigate to="/landing-page" replace />} />
        <Route path="/landing-page" element={
          <PublicRoute>
            <LandingPage />
          </PublicRoute>
        } />
        <Route path="/login" element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        } />
        <Route path="/employee-login" element={
          <PublicRoute>
            <EmployeeLogin />
          </PublicRoute>
        } />
        <Route path="/sso/launch" element={<SsoLaunchPage />} />
        
        {/* Protected Routes */}
        <Route path="/compliance-reports" element={
          <ProtectedRoute>
            <ComplianceReports />
          </ProtectedRoute>
        } />
        <Route path="/auditor-portal" element={
          <ProtectedRoute>
            <AuditorPortal />
          </ProtectedRoute>
        } />
        <Route path="/data-integration" element={
          <ProtectedRoute>
            <DataIntegration />
          </ProtectedRoute>
        } />
        <Route path="/analytics-dashboard" element={
          <ProtectedRoute>
            <AnalyticsDashboard />
          </ProtectedRoute>
        } />
        <Route path="/employee-portal" element={
          <ProtectedRoute>
            <EmployeePortal />
          </ProtectedRoute>
        } />
        <Route path="/pay-band-management" element={
          <ProtectedRoute>
            <PayBandManagement />
          </ProtectedRoute>
        } />
        <Route path="/joint-assessments" element={
          <ProtectedRoute>
            <JointAssessments />
          </ProtectedRoute>
        } />
        <Route path="/settings" element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        } />
        <Route path="/approvals" element={
          <ProtectedRoute>
            <ApprovalsPage />
          </ProtectedRoute>
        } />
        <Route path="/admin/console" element={
          <ProtectedRoute>
            <AdminConsolePage />
          </ProtectedRoute>
        } />
        
        {/* Catch all route */}
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;